import React from 'react';
import { VictoryLabel, VictoryPie, VictoryTooltip } from 'victory';

const CustomLabel = (props: any) => {
    return (
      <>
        <VictoryLabel {...props} />
        <VictoryTooltip
          {...props}
          x={200}
          y={250}
          orientation='top'
          pointerLength={0}
          cornerRadius={50}
          flyoutWidth={100}
          flyoutHeight={100}
          flyoutStyle={{ fill: 'black', fontSize: '20px' }}
        />
      </>
    );
}

export const ChartPieComponent = (pData: any, pProperties: any) => {
  const colorScale = pData.map((line: any) => line.color);
  return (
    <>
      <VictoryPie
        style={{
          labels: { fill: 'black', fontSize: pProperties.fontSizeGraphic },
          parent: { position: 'relative', left: '3vw' },
        }}
        innerRadius={pProperties.innerRadius}
        labelRadius={160}
        labels={({ datum }) =>
          `${datum.note} ${datum.pourcentage}`
        }
        labelComponent={<CustomLabel {...pProperties} />}
        data={pData}
        labelPosition={(index) => (index ? 'centroid' : 'startAngle')}
        colorScale={colorScale}
      />
    </>
  );
};
